/**
 * labels.ts — display-label helpers for raw enum / tag tokens.
 *
 * humanizeEnum is the generic fallback used wherever the UI would otherwise show
 * a raw snake_case / kebab-case value (dominant_type enums, OSM amenity keys).
 * Explicit label maps (e.g. DOMINANT_TYPE_LABELS) take precedence; humanizeEnum
 * only handles values not covered by such a map.
 */

/** Split on `_`, `-`, or whitespace and Title-Case each word. Interior capitals
 *  are preserved (the tail of each word is left as-is), so acronyms survive.
 *  Null-safe (F2/T-082): a nullish token (e.g. a tract whose bbox props omit
 *  dominant_type) returns '' instead of throwing on `.split`. */
export function humanizeEnum(s: string | null | undefined): string {
  if (!s) return ''
  return s
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}
